import React from 'react';
import { Select } from 'new/elements/Select';
import { useDispatch } from 'react-redux';
import { updateFormData } from 'js/actions';
import { FORM_TYPE_CREATE_REUSABLE_TX } from 'js/constants/formTypes';
import { TextField } from 'new/elements/TextField';
import { TransformParameterTypes } from 'js/constants/schemaEditor';
import { ReusableTransformUtil } from 'new/utils/ReusableTransform/argumentValues';
import { getCurrentSelectedOption } from 'js/components/elements/rselect/ReactSelectUtils';

import './FunctionArgsValues.scss';
import {
  handleUpdateArgsTestData,
  handleUpdateParamAttribute,
  HandleUpdateParamAttributeParameters as onParamAttributeChangedParams,
} from '.';

type Props = {
  inputAttrs: string[];
  argumentValues: Array<{ name: string; description: string }>;
  argumentsTestData: Array<{ fName: string; type: string; value: any }>;
};

type OnParamAttributeChangedParams = (a: onParamAttributeChangedParams) => void;

function FunctionArgsValues(props: Props) {
  const { inputAttrs = [], argumentValues = [], argumentsTestData = [] } = props;

  const dispatch = useDispatch();
  const updateArgumentsTestData = (
    idx = -1,
    target: { value: 'string' | 'number' | 'attributeRef'; name: 'type' },
  ) => {
    if (argumentsTestData.length === 0) return;

    const inputForm = handleUpdateArgsTestData(idx, target, argumentsTestData, inputAttrs);

    dispatch(updateFormData(FORM_TYPE_CREATE_REUSABLE_TX, inputForm));
  };

  const onParamAttributeChanged: OnParamAttributeChangedParams = (param) => {
    if (argumentsTestData.length === 0) return;
    const txArgsTestData = handleUpdateParamAttribute(param, argumentsTestData);
    dispatch(updateFormData(FORM_TYPE_CREATE_REUSABLE_TX, { txArgsTestData }));
  };

  return (
    <div className="function-args-values">
      <span className="title">Function Argument Values</span>

      <ul aria-label="function-arg-values-list" className="thin-scroll-bar-style">
        {argumentValues.map((value, idx) => {
          let inputElement: {};
          const lineNumber = idx + 1;
          const key = 'arg-option-' + lineNumber;

          const currentOption = ReusableTransformUtil.getCurrentOptionValue(argumentsTestData, idx);
          const { currentValue, currentType } = currentOption;

          if (currentType === TransformParameterTypes.ATTR_REF) {
            let options = inputAttrs.map((a) => ({
              title: a,
              value: a,
            }));

            const currentSelectedOption = getCurrentSelectedOption(options, currentValue);
            const config = { idx, type: currentType, fName: value.name };
            const inputSelectValue = currentSelectedOption?.value ?? options[0]?.value;

            inputElement = (
              <Select
                value={inputSelectValue}
                items={options}
                defaultValue="Attibute"
                className="input-select"
                onChange={(e: any) => {
                  onParamAttributeChanged({
                    ...config,
                    option: {
                      label: e.target.value,
                      value: e.target.value,
                    },
                  });
                }}
              />
            );
          } else {
            const inputCurrentValue = currentValue ?? '';
            inputElement = (
              <TextField
                name="value"
                value={inputCurrentValue}
                variant="outlined"
                className="input-select"
                placeholder="Apply on attribute"
                onChange={(e: any) => updateArgumentsTestData(idx, e.target)}
              />
            );
          }

          return (
            <li className="line" key={key}>
              <div>
                <span className="line-number">{lineNumber}</span>
                <div className="info">
                  <span className="name">{value.name}</span>
                  <span className="description">{value.description}</span>
                </div>
              </div>

              <div className="select">
                <Select
                  name="type"
                  className="input-select"
                  value={currentType}
                  defaultValue="Attibute"
                  items={ReusableTransformUtil.SELECTION_OPTIONS_TYPE}
                  onChange={(e: any) => updateArgumentsTestData(idx, e.target)}
                />
              </div>

              <div>{inputElement}</div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default FunctionArgsValues;
